<template>
  <div id="notice" class="z4 flex py0 pl1 justify-between items-center font-size-small">
    <div class="pr3">{{ text }}</div>
    <div class="button py1 px3">Ok</div>
  </div>
</template>

<script>
export default {

  name: 'Notice',

  data () {
    return {
    }
  },

  props: ['text']
}
</script>

<style lang="css" scoped>
  #notice {
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background: var(--color-green);
    transition: all 0.3s ease-out;

    .button {
      border-left: 1px solid var(--color-black);
    }

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }

    &:hover {
      .button {
        background: var(--color-black);
        color: var(--color-green);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue